import { useEffect, useState } from 'react';

interface GeoResponse {
  country: string | null;
}

export function useRegion(): string | null {
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    if (import.meta.env.DEV) {
      setCountry('US'); // dev-only override for local testing — remove before shipping
      return;
    }
    fetch('/api/geo')
      .then((r) => r.json() as Promise<GeoResponse>)
      .then((d) => setCountry(d.country ?? null))
      .catch(() => setCountry(null));
  }, []);

  return country;
}
